import Studios, {
  IStudioFilterResultRequests,
  IStudios,
  IStudiosApi,
} from '@models/Studios.model';
import { onboarding } from '@services';

interface IIStudios {
  search?: string;
}

const getStudios = async ({
  search,
}: IIStudios): Promise<IStudioFilterResultRequests<IStudios>> => {
  const { data: assets } = await onboarding.get<
    IStudioFilterResultRequests<IStudiosApi>
  >(`api/v1/file/studios?search=${search}`);

  return Studios.arrayPaginatedFromApiModel(assets);
};

export { getStudios };
